var styles = {"th":"styles_th__dDruf","resizeHandle":"styles_resize-handle__Vp9Uq"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
